import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import TableWidget from '../../TableWidget.js';

//components
import withLocalization from '~/hoc/withLocalization';

//elements
import { NumberInput, Input } from '../../../../../elements/Input';
import SwitchWidget from '../../SwitchWidget';

//utils
import { currentYearCycle } from '../../../../../utils/commonMethods';
import { CLIENT_RULE_CHANGE_VALIDATORS } from '../../../../../utils/constants.js';

class SocialWelfare extends Component {
    constructor(props) {
        super(props);
        const { currentEntity } = props.clientStore;
        const basicRules = Object.assign({}, currentEntity.client.data.basicRules);
        this.state = {
            socialWelfareLeaves: {
                isSocialWelfareLeavesEditable: false,
                allowSocialWelfareLeave: basicRules.allowSocialWelfareLeave,
                allowTimesheetWithSocialWelfareLeave: basicRules.allowTimesheetWithSocialWelfareLeave,
                allowTimesheetWithSocialWelfareLeave100Percent: basicRules.allowTimesheetWithSocialWelfareLeave100Percent,
                socialWelfareLeaveHours: basicRules.socialWelfareLeaveHours,
                socialWelfareSubTypes: basicRules.socialWelfareSubTypes || [],
            }
        }
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        const { clientStore } = this.props;
        const basicRules = Object.assign({}, clientStore.currentEntity.client.data.basicRules);

        this.setState({
            socialWelfareLeaves: {
                ...this.state.socialWelfareLeaves,
                socialWelfareSubTypes: (basicRules.socialWelfareSubTypes || []).sort((a, b) => a.name.localeCompare(b.name)),
            }
        })
    }

    handleChange = (name, value) => {
        const { socialWelfareLeaves } = this.state;
        const { clientStore, commonStore, t } = this.props;

        socialWelfareLeaves[name] = value;

        if (name === 'allowTimesheetWithSocialWelfareLeave') {
            if (!value) {
                socialWelfareLeaves.allowTimesheetWithSocialWelfareLeave100Percent = false;
                this.props.handleUserDataChange('allowTimesheetWithSocialWelfareLeave100Percent', false);
            }
        }

        this.props.handleUserDataChange(name, value);

        if (name === 'allowSocialWelfareLeave') {
            if (value) {
                const extendedRules = Object.assign({}, clientStore.currentEntity.client.data.extendedRules);
                const socialWelfareType = extendedRules.absent_types.find((item) => item.code === 'social-welfare');
                if (!socialWelfareType) {
                    extendedRules.absent_types.unshift({ code: 'social-welfare', name: 'Social Welfare' });
                }
                this.props.handleClientRuleChange('extendedRules', extendedRules);
            } else {
                const extendedRules = Object.assign({}, clientStore.currentEntity.client.data.extendedRules);
                const absenceTypes = extendedRules.absent_types.filter((item) => item.code !== 'social-welfare');
                extendedRules.absent_types = absenceTypes;
                this.props.handleClientRuleChange('extendedRules', extendedRules);
            }
        }

        if (name === 'socialWelfareLeaveHours') {
            const extendedRules = Object.assign({}, clientStore.currentEntity.client.data.extendedRules);
            this.props.handleClientRuleChange('extendedRules', extendedRules)
            if (value < clientStore.validateClientRuleChangeResponse.socialWelfare.maxSocialWelfareHoursUsed) {
                const message = t('Social welfare leave hours can not be less than used hours') + ` ${clientStore.validateClientRuleChangeResponse.socialWelfare.maxSocialWelfareHoursUsed}`;
                commonStore.addNotification(t(message), null, 'warning', 'top-right', 3000);
            }
        }

        this.setState({ socialWelfareLeaves });
    }

    handleSocialWelfareLeavesEdit = async () => {
        const { clientStore } = this.props;

        await clientStore.validateClientRuleChange({ changeType: CLIENT_RULE_CHANGE_VALIDATORS.ABSENCE_SOCIAL_WELFARE_LEAVE_CHANGE }, 'absence');

        this.setState({
            socialWelfareLeaves: {
                ...this.state.socialWelfareLeaves,
                isSocialWelfareLeavesEditable: !this.state.socialWelfareLeaves.isSocialWelfareLeavesEditable
            }
        })
    }

    handleDataChange = (data, name, evt, index, isNew) => {
        const { socialWelfareLeaves } = this.state;
        const { commonStore, t, clientStore } = this.props;
        if (isNew) {
            data['code'] = data['name'].toLowerCase().replace(/\s+/g, '_');
            return;
        }

        if (!socialWelfareLeaves.isSocialWelfareLeavesEditable)
            return commonStore.addNotification(t('Please enable edit mode'), null, 'error');

        if (clientStore.validateClientRuleChangeResponse.socialWelfare.usedSocialWelfareLeaveTypes.includes(data[index].code))
            return commonStore.addNotification(t('Social welfare types already in use'), null, 'error');

        if (!isNew) {
            data[index][name] = evt.target.value;
            data[index]['code'] = evt.target.value.toLowerCase().replace(/\s+/g, '_');
        }
    }

    handleDeleteSocialWelfareSubType = (idx) => {
        const { socialWelfareLeaves } = this.state;
        const { commonStore, t, clientStore } = this.props;
        if (!socialWelfareLeaves.isSocialWelfareLeavesEditable)
            return commonStore.addNotification(t('Please enable edit mode'), null, 'error');

        if (clientStore.validateClientRuleChangeResponse.socialWelfare.usedSocialWelfareLeaveTypes.includes(socialWelfareLeaves.socialWelfareSubTypes[idx].code))
            return commonStore.addNotification(t('Social welfare types already in use'), null, 'error');

        const updatedSocialWelfareSubTypes = [...socialWelfareLeaves.socialWelfareSubTypes];
        updatedSocialWelfareSubTypes.splice(idx, 1);
        this.setState({ socialWelfareLeaves: { ...socialWelfareLeaves, socialWelfareSubTypes: updatedSocialWelfareSubTypes } }, () => {
            this.handleChange('socialWelfareSubTypes', updatedSocialWelfareSubTypes);
        });
    }

    render() {
        const { socialWelfareLeaves } = this.state;
        const { t, commonStore } = this.props;

        const dateTimeRules = commonStore.getDateTimeRules();
        const { short_date_format } = dateTimeRules;
        const timezoneGMT = commonStore?.config?.timezoneGMT || 0;

        let headers = ['Label'];
        let metaData = [{ field: 'name', type: 'text', placeholder: 'Label', required: true, unique: true, uniqueWithoutCase: true }];

        return (
            <div>
                <div className="d-flex align-items-center justify-content-start mt-2 gap-3 w-100">
                    <div className="d-flex align-items-center">
                        <label className="control-label font-size-15 mb-0 font-color-primary">
                            {t('Social Welfare')}
                            <OverlayTrigger
                                placement="bottom"
                                overlay={
                                    <Tooltip id="tooltip-top">
                                        {t("Enable Social Welfare Leave")}
                                    </Tooltip>
                                }
                            >
                                <i
                                    className="fa fa-info-circle text-muted ms-1"
                                    style={{ opacity: 0.5 }}
                                />
                            </OverlayTrigger>
                        </label>
                    </div>
                    <div className="d-flex align-items-center">
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="Edit-SocialWelfare">
                                    {t("Enable edit mode")}
                                </Tooltip>
                            }
                        >
                            <i
                                className="fa fa-edit font-size-15 cursor-pointer font-color-primary"
                                onClick={() => this.handleSocialWelfareLeavesEdit()}
                            />
                        </OverlayTrigger>
                    </div>
                </div>
                <hr />
                <Row className='mt-1'>
                    <Col xs={12} md={6}>
                        <Row className='mt-2 align-items-center'>
                            <Col xs={8}>
                                <label className="control-label">{t('Enable Social Welfare Leave')}</label>
                            </Col>
                            <Col xs={4}>
                                <SwitchWidget
                                    value={socialWelfareLeaves.allowSocialWelfareLeave}
                                    disabled={!socialWelfareLeaves.isSocialWelfareLeavesEditable}
                                    onChange={(checked) => this.handleChange('allowSocialWelfareLeave', checked)}
                                />
                            </Col>
                        </Row>
                        <Row className='mt-1 align-items-center'>
                            <Col xs={8}>
                                <label className="control-label">{t('Allow Timesheet with Social Welfare Leave')}</label>
                            </Col>
                            <Col xs={4}>
                                <SwitchWidget
                                    value={socialWelfareLeaves.allowTimesheetWithSocialWelfareLeave}
                                    disabled={!socialWelfareLeaves.isSocialWelfareLeavesEditable}
                                    onChange={(checked) => this.handleChange('allowTimesheetWithSocialWelfareLeave', checked)}
                                />
                            </Col>
                        </Row>
                        <Row className='mt-1 align-items-center'>
                            <Col xs={8}>
                                <label className="control-label">{t('Allow Timesheet with Social Welfare Leave 100%')}</label>
                            </Col>
                            <Col xs={4}>
                                <SwitchWidget
                                    value={socialWelfareLeaves.allowTimesheetWithSocialWelfareLeave100Percent}
                                    disabled={!socialWelfareLeaves.isSocialWelfareLeavesEditable || !socialWelfareLeaves.allowTimesheetWithSocialWelfareLeave}
                                    onChange={(checked) => this.handleChange('allowTimesheetWithSocialWelfareLeave100Percent', checked)}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} md={6}>
                        <Row className='align-items-center'>
                            <Col xs={4}>
                                <label className="control-label">{t('Leave Cycle')}
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("The social welfare leave cycle follows the calendar year, and the leaves allocated to employees resets at the beginning of the year")}.
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={8}>
                                <Input
                                    disabled
                                    onChange={_ => { }}
                                    value={currentYearCycle(short_date_format, timezoneGMT)}
                                />
                            </Col>
                        </Row>
                        <Row className='mt-2 align-items-center'>
                            <Col xs={8}>
                                <label className="control-label">{t('Social Welfare Leave Hours')}</label>
                            </Col>
                            <Col xs={4}>
                                <NumberInput
                                    value={socialWelfareLeaves.socialWelfareLeaveHours}
                                    disabled={!socialWelfareLeaves.isSocialWelfareLeavesEditable}
                                    onChange={evt => this.handleChange('socialWelfareLeaveHours', parseInt(evt.target.value, 10))}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row className='mt-3'>
                    <TableWidget
                        headers={headers}
                        metaData={metaData}
                        data={socialWelfareLeaves.socialWelfareSubTypes}
                        onChange={_ => { }}
                        customHandleChange={this.handleDataChange}
                        customDeleteHandler={this.handleDeleteSocialWelfareSubType}
                    />
                </Row>

            </div >
        );
    }
}
export default inject('clientStore', 'commonStore')(withLocalization(observer(SocialWelfare)));
